export const TABS_OPTIONS = [
  { key: 'experience', label: 'Experience' },
  { key: 'job_assigned', label: 'Job assigned' },
];
